import { addMessages, init, getLocaleFromNavigator } from "svelte-i18n";

import de from "../../public/locale/de.json";
import en from "../../public/locale/en.json";
import es from "../../public/locale/es.json";
import pt from "../../public/locale/pt.json";

addMessages("en", en);
addMessages("de", de);
addMessages("es", es);
addMessages("pt", pt);

export function i18nInit() {
  init({
    fallbackLocale: "de",
    initialLocale: getLocaleFromNavigator(),
  });
}
